import { useState, useEffect } from "react";
import { Card, Form, Button, Spinner, Alert } from "react-bootstrap";
import APIFunction from "../util/api";
import { INFO_STATEMENTS } from "../util/constants";

export default function SavingsPlanModal({ show, onClose }) {
    const [form, setForm] = useState({
        name: "",
        packageName: "",
        description: "",
        target: "",
    });
    const [loading, setLoading] = useState(false);
    const [packages, setPackages] = useState([]);
    const [loadingPackages, setLoadingPackages] = useState(false);
    const [status, setStatus] = useState(null);

    useEffect(() => {
        if (show) {
          fetchPackages();
          clearFields();
        }
    }, [show]);

    const fetchPackages = async () => {
        setLoadingPackages(true);
        try {
          const response = await APIFunction.getPackages()
          if (response) {
            setPackages(response);
          }
        } catch (error) {
          console.error("Error fetching packages:", error);
          setPackages([]);
        } finally {
            setLoadingPackages(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const clearFields = () => {
        setForm({
          description: "",
          packageName: "",
          name: "",
          target: "",
        });
        setStatus(null)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus("waiting");

        try {
            const payload = {
                packageName: form.packageName,
                description: form.description,
                name: form.name,
                target: form.target,
            };

            const savingPlan = await APIFunction.createSavingsPlan(payload)
            if (savingPlan.name === form.name) {
                setStatus(INFO_STATEMENTS.SUCCESS);
                setLoading(false);
      
                setTimeout(() => {
                  onClose();
                }, 2000);
                return;
            }
            setStatus(INFO_STATEMENTS.FAILED);
            setLoading(false);
            return;

        } catch (err) {
            console.error(err);
            setStatus(INFO_STATEMENTS.FAILED);
            setLoading(false);
        }
    }
    if (!show) return null;

    return (
        <div className="modal-backdrop">
            <Card className="transaction-modal-card">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                        <i className="bi bi-piggy-bank me-2"></i>
                        Create Saving Plan
                    </h5>
                    <Button 
                        variant="outline-secondary" 
                        size="sm" 
                        onClick={onClose}
                        disabled={loading}
                    >
                        <i className="bi bi-x-lg"></i>
                    </Button>
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                <i className="bi bi-input-cursor-text me-2"></i>
                                Name
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                placeholder="Enter plan name"
                                value={form.name}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                <i className="bi bi-currency-dollar me-2"></i>
                                Target
                            </Form.Label>
                            <Form.Control
                                type="number"
                                name="target"
                                placeholder="Enter target"
                                value={form.target}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label>
                                <i className="bi bi-box me-2"></i>
                                Package
                            </Form.Label>
                            {loadingPackages ? (
                                <div className="d-flex align-items-center">
                                <Spinner animation="border" size="sm" className="me-2" />
                                <span>Loading packages...</span>
                                </div>
                            ) : (
                                <Form.Select
                                    name="packageName"
                                    value={form.packageName}
                                    onChange={handleChange}
                                    required
                                    >
                                    <option value="">Select a package...</option>
                                    {packages.map((packageItem) => (
                                        <option key={packageItem.id} value={packageItem.name}>
                                            {packageItem.name} - {packageItem.description || 'No description'}
                                        </option>
                                    ))}
                                </Form.Select>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label>
                                <i className="bi bi-justify me-2"></i>
                                description
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="description"
                                placeholder="enter description (optional)"
                                value={form.description}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        {status === "waiting" && (
                            <Alert variant="info" className="d-flex align-items-center">
                                <Spinner animation="border" size="sm" className="me-2" />
                                Processing, please wait ⏳
                            </Alert>
                        )}
                        
                        {status === INFO_STATEMENTS.SUCCESS && (
                            <Alert variant="success">
                                <i className="bi bi-check-circle me-2"></i>
                                Saving plan create successful ✅
                            </Alert>
                        )}

                        {status === INFO_STATEMENTS.FAILED && (
                            <Alert variant="danger">
                                <i className="bi bi-exclamation-triangle me-2"></i>
                                Saving plan create failed ❌ Please try again
                            </Alert>
                        )}

                        <div className="d-flex gap-2">
                            <Button 
                                type="submit" 
                                variant="primary" 
                                disabled={loading}
                                className="flex-fill"
                            >
                                {loading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Processing...
                                </>
                                ) : (
                                <>
                                    <i className="bi bi-piggy-bank me-2"></i>
                                    Create saving plan
                                </>
                                )}
                            </Button>
                            
                            <Button 
                                variant="outline-secondary" 
                                onClick={onClose}
                                disabled={loading}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    )
}